import React from 'react';

type DisplayOnlyProps = {};

export const DisplayOnly: React.FunctionComponent<DisplayOnlyProps> = ({
                                                                           children
                                                                       }): JSX.Element => {
    return (
        <div className={'field-display-only'}>{children}</div>
    );
}